import {
  DEPENDANT_INSIDE_SERVICE_TYPE,
  ELIGIBILITY_CHECK_SERVICE_TYPE,
  REPORT_GENERATION_SERVICE_STATUS,
  SPONSOR_LICENCE_SERVICE_TYPE,
  SW_SERVICES_TYPES,
} from "@/constants/services";
import { app } from "@/main";
import { API_TCaseDashboard, API_TCaseDashboardWidget } from "@/models/case_dashboard";
import { API_TCaseTab } from "@/models/case_tabs";
import {
  API_TCase,
  TCase_Dependant_Applicant,
  TCase_Main_Applicant,
  TOther_Case,
} from "@/models/cases";
import { API_TCase_Expert, convertCasesForTable, TCase_Table } from "@/models/cases_expert";
import axios from "@/plugins/http";
import { SMApp, SMUser } from "@/store";
import { API_ROUTES } from "@/utils/API";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

const SERVICES = "services";
const CASES = "cases";
const EMPLOYER_CANDIDATES_PATH = "/employer/visa-cases";
const EMPLOYER_COMPANY_SL_PATH = "/employer/company/sponsor_licence";

@Module({ name: "MCases", namespaced: true })
export default class MCases extends VuexModule {
  tabId = 0;

  caseTabs: API_TCaseTab[] = [];

  caseId = 0;

  slCaseId = 0;

  get currentCaseId() {
    return this.case.ID;
  }

  case = { ID: 0 };

  documentId = 0;

  onlineApplicationStatus = "";

  onlineApplicationInitialStatus = "";

  caseStatus = "";

  caseStepName = "";

  caseStepAlias = "";

  widgetNeedsUpdate = false;

  caseType = "";

  caseTemplateId = 0;

  hasTasks = false;

  isArchived = false;

  get isDependantCase() {
    return [DEPENDANT_INSIDE_SERVICE_TYPE].includes(this.caseType);
    // return !!((this.case as unknown) as { parent_case_id: number })?.parent_case_id;
  }

  get isReportGenerationProcess() {
    return this.caseStatus === REPORT_GENERATION_SERVICE_STATUS;
  }

  mainApplicant: TCase_Main_Applicant = {
    first_name: "",
    last_name: "",
    job_title: "",
  };

  dependantApplicant?: TCase_Dependant_Applicant = {
    first_name: "",
    last_name: "",
    title: "",
    case_created: false,
  };

  ownerId = 0;

  casesCandidate: API_TCase_Expert[] = [];
  cases: TCase_Table[] = [];
  isLastStep = false;

  serviceData: API_TCase = {} as API_TCase;

  caseLayoutTabs: API_TCaseTab[] = [] as API_TCaseTab[];

  loading = false;

  caseAlias = "";

  dashboardKey = 0;

  serviceWithEnableStartDependantsVisa = "";

  @Mutation
  setCasesCandidate(payload: API_TCase_Expert[]) {
    this.casesCandidate = payload;
  }

  @Mutation
  setCasesExpert(payload: API_TCase_Expert[]) {
    this.cases = payload.map((a) => convertCasesForTable(a));
  }

  @Mutation
  setCases(payload: any) {
    this.cases = payload;
  }

  @Mutation
  setServiceWithEnableStartDependantsVisa(payload: any) {
    if (!payload?.length) return;

    this.serviceWithEnableStartDependantsVisa = payload.find((service) => {
      return (
        Object.prototype.hasOwnProperty.call(service, "can_start_dependant_case") &&
        service.can_start_dependant_case === true
      );
    });
  }

  @Mutation
  setCaseId(payload: number) {
    this.caseId = payload;
  }

  @Mutation
  setCase(payload: API_TCase_Expert) {
    this.case = payload;
  }

  @Mutation
  setTabId(payload: number) {
    this.tabId = payload;
  }

  @Mutation
  setCaseTabs(payload: API_TCaseTab[]) {
    this.caseTabs = payload;
  }

  @Mutation
  setDocumentId(payload: number) {
    if (payload) {
      this.documentId = payload;
    }
  }

  @Mutation
  setOnlineApplicationStatus(payload: string) {
    this.onlineApplicationStatus = payload;
  }

  @Mutation
  setOnlineApplicationInitialStatus(payload: string) {
    this.onlineApplicationInitialStatus = payload;
  }

  @Mutation
  setCaseStatus(payload: string) {
    this.caseStatus = payload;
  }

  @Mutation
  setCaseStepName(payload: string) {
    this.caseStepName = payload;
  }

  @Mutation
  setCaseStepAlias(payload: string) {
    this.caseStepAlias = payload;
  }

  @Mutation
  setWidgetNeedsUpdate(payload: boolean) {
    this.widgetNeedsUpdate = payload;
  }

  tasksTableNeedsUpdate = false;

  @Mutation
  setTasksTableNeedsUpdate(payload: boolean) {
    this.tasksTableNeedsUpdate = payload;
  }

  @Mutation
  setCaseType(payload: string) {
    this.caseType = payload;
  }

  @Mutation
  setCaseAlias(payload: string) {
    // dependant_inside
    // candidate_assessment
    // cos_sw_inside
    // cos_sw
    // skilled_worker
    // sw_inside
    // sponsor_licence
    this.caseAlias = payload;
  }

  @Mutation
  setCaseTemplateId(payload: number) {
    this.caseTemplateId = payload;
  }

  @Mutation
  setLastStep(payload: boolean) {
    this.isLastStep = payload;
  }

  @Mutation
  setHasTasks(payload: boolean) {
    this.hasTasks = payload;
  }

  @Mutation
  setIsArchived(payload: boolean) {
    this.isArchived = payload;
  }

  isNpsRated = false;

  @Mutation
  setIsRated(payload: boolean) {
    this.isNpsRated = payload;
  }

  otherCases: TOther_Case[] = [];

  @Mutation
  setOtherCases(payload: TOther_Case[]) {
    this.otherCases = payload;
  }

  isExtension = false;

  @Mutation
  setIsExtension(payload: boolean) {
    this.isExtension = payload;
  }

  @Mutation
  setMainApplicant(payload: TCase_Main_Applicant) {
    this.mainApplicant = payload;
  }

  @Mutation
  setDependantApplicant(payload: TCase_Main_Applicant) {
    this.dependantApplicant = payload;
  }

  @Mutation
  setCaseOwnerId(payload: number) {
    this.ownerId = payload;
  }

  @Mutation
  updateDashboardKey() {
    // this.dashboardKey = this.dashboardKey += 1;
  }

  @Mutation
  setStorageCaseId() {
    const id = Number(localStorage.getItem("case_id"));

    if (id === this.caseId) return;

    localStorage.setItem("case_id", String(this.caseId));

    this.caseId = id;
  }

  @Action
  async getTableCases() {
    const { data } = await axios.get<API_TCase_Expert[]>(API_ROUTES.CASE());

    SMUser.isCandidate ? this.setCasesCandidate(data) : this.setCasesExpert(data);
  }

  @Action
  async getCases() {
    const { data } = await axios.get(API_ROUTES.CASE());

    this.setCases(data);

    this.setServiceWithEnableStartDependantsVisa(data);
  }

  @Mutation
  setCaseLayoutTabs() {
    const tabs = this.serviceData?.case_template?.case_layout_tabs;

    if (!tabs) return;

    this.caseLayoutTabs = tabs.sort((a, b) => a.index - b.index);

    this.tabId = this.caseLayoutTabs[0].tab_type_id;

    this.caseTabs = this.caseLayoutTabs;

    const documentsTab = this.serviceData.case_template.case_layout_tabs.find((i) =>
      ["Documents", "documents"].includes(i.tab_name)
    );

    const hasSLCandidateTab = this.serviceData.case_template.case_layout_tabs.find((i) =>
      ["Candidates"].includes(i.tab_name)
    );

    SMApp.setHasSlCandidatesTab(!!hasSLCandidateTab);

    if (documentsTab && documentsTab.tab_type_id) this.documentId = documentsTab.tab_type_id;
  }

  // @Mutation
  // navigateFirstTab() {
  //   const firstTab = this.caseLayoutTabs && this.caseLayoutTabs[0] ? this.caseLayoutTabs[0] : null;

  //   if (!firstTab || app.$route.path.includes(`${this.caseId}/`)) return;

  //   const path = `/cases/${this.caseId}/${firstTab.tab_type}/${firstTab.tab_type_id}`;

  //   if (app.$route.path !== path) app.$router.push(path);
  // }

  pageTitle = "";

  pageSection = "";

  pageTitleLink = "";

  @Mutation
  updatePageTitle() {
    const { ID, case_template, main_applicant, company_name } = this.serviceData;

    let serviceName = case_template?.name || "";

    if (serviceName === app.$root.$tc("services.candidateAssessment")) {
      serviceName = app.$root.$tc("services.candidateEligibilityCheck");
    }

    if (SMUser.isExpert) serviceName = case_template.name_dev;

    let name = `${app.$root.$tc("modules.names.services")}`;

    let sectionName = "";

    if (SMUser.isExpert) {
      if (
        ([...SW_SERVICES_TYPES].includes(case_template.case_type) ||
          [ELIGIBILITY_CHECK_SERVICE_TYPE].includes(case_template.name_dev)) &&
        main_applicant
      ) {
        sectionName += ` > ${company_name}`;
      }

      if ([DEPENDANT_INSIDE_SERVICE_TYPE].includes(case_template.case_type)) {
        sectionName += ` > ${company_name}`;
      }
    }

    sectionName += ` > ${ID} ${serviceName}`;

    // if (main_applicant?.job_title) sectionName += ` (${main_applicant.job_title})`;

    if (SMUser.isExpert) {
      if (
        ([...SW_SERVICES_TYPES].includes(case_template.case_type) ||
          [ELIGIBILITY_CHECK_SERVICE_TYPE].includes(case_template.name_dev)) &&
        main_applicant
      ) {
        const applicantName = `${main_applicant.first_name} ${main_applicant.last_name}`;

        sectionName += ` > ${applicantName}`;
      }

      if ([DEPENDANT_INSIDE_SERVICE_TYPE].includes(case_template.case_type)) {
        const { dependant_applicant } = this.serviceData;

        const dependantName = `${dependant_applicant.first_name} ${dependant_applicant.last_name}`;

        sectionName += ` > ${dependantName}`;
      }

      if ([SPONSOR_LICENCE_SERVICE_TYPE].includes(case_template.case_type) && company_name) {
        sectionName += ` > ${company_name}`;
      }
    }

    let path = SMUser.isCandidate
      ? `/${CASES}`
      : SMUser.isExpert
      ? `${SMUser.basePath}/${CASES}`
      : `${SMUser.basePath}/${SERVICES}`;

    if (SMUser.isEmployer) {
      name = `${app.$root.$tc("modules.names.visaCases")}`;

      path = EMPLOYER_CANDIDATES_PATH;

      if (serviceName === app.$root.$tc("services.sponsorLicence")) {
        name = `${app.$root.$tc("modules.names.company")}`;

        path = EMPLOYER_COMPANY_SL_PATH;
      }
    }

    SMApp.setPageTitle(name);

    SMApp.setPageSection(sectionName);

    SMApp.setPageTitleLink(path);

    this.pageTitle = name;

    this.pageSection = sectionName;

    this.pageTitleLink = path;
  }

  @Mutation
  setServiceData(payload: API_TCase) {
    this.serviceData = payload;
  }

  @Mutation
  setLoading(payload: boolean) {
    this.loading = payload;
  }

  @Action
  async fetchCaseTabs(caseId: number) {
    try {
      if (!caseId) return;

      this.updateDashboardKey();

      this.setCaseId(caseId);

      const { data } = await axios.get(API_ROUTES.CASE_ID(caseId, true));

      if (!data) return;

      this.setServiceData(data);

      this.setCase(data);

      this.setCaseLayoutTabs();

      // this.navigateFirstTab();

      const {
        online_application_status,
        status,
        case_progress_step,
        case_template,
        case_template_id,
        owner_id,
        is_archived,
        rated,
        other_cases,
        is_extension,
      } = this.serviceData;

      this.updatePageTitle();

      this.setOnlineApplicationStatus(online_application_status);
      this.setOnlineApplicationInitialStatus(online_application_status);
      this.setCaseStatus(status);
      this.setCaseStepName(case_progress_step.name);
      this.setCaseStepAlias(case_progress_step.alias);
      this.setCaseType(case_template.case_type);
      this.setCaseTemplateId(case_template_id);
      this.setCaseOwnerId(owner_id);
      this.setCaseAlias(case_template.alias);
      this.setIsArchived(is_archived);
      this.setIsRated(rated);
      this.setOtherCases(other_cases);
      this.setIsExtension(is_extension);

      if (data.main_applicant as TCase_Main_Applicant) {
        this.setMainApplicant(data.main_applicant);
      }

      this.setStorageCaseId();
    } finally {
      // this.setLoading(false);
    }
  }

  // VTemplateDashboard

  dashboard: API_TCaseDashboard = {} as API_TCaseDashboard;

  serviceLayoutWidgets: API_TCaseDashboardWidget[] = [] as API_TCaseDashboardWidget[];

  @Mutation
  setDashboard(payload: API_TCaseDashboard) {
    this.dashboard = payload;
  }

  @Mutation
  setServiceLayoutWidgets(payload: API_TCaseDashboardWidget[]) {
    this.serviceLayoutWidgets = payload;
  }

  @Action
  async fetchDashboard(caseId: number) {
    try {
      this.setLoading(true);

      const serviceDashboardId = this.tabId;

      if (!serviceDashboardId) return console.log("No case_template_layout.tabs");

      const { data } = await axios.get(API_ROUTES.CASE_DASHBOARD(caseId, serviceDashboardId));

      if (!data) return;

      this.setDashboard(data);

      this.setServiceLayoutWidgets(
        data.case_dashboard_widgets.sort(
          (a: API_TCaseDashboardWidget, b: API_TCaseDashboardWidget) => a.index - b.index
        )
      );
    } finally {
      // this.setLoading(false);
    }
  }

  serviceNeedsUpdate = false;

  @Mutation
  setServiceNeedsUpdate(payload: boolean) {
    this.serviceNeedsUpdate = payload;
  }

  @Action
  async updateService() {
    if (!this.serviceNeedsUpdate) return;

    if (!this.caseId) return;

    await this.fetchCaseTabs(this.caseId);

    this.setServiceNeedsUpdate(false);
  }
}
